var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_vm._v(" 禾下月/"),_c('a',{attrs:{"href":"https://hxyxyz.top"}},[_vm._v("小小窝")])])}]

export { render, staticRenderFns }